import api from '../config/api';
import {
  FETCH_COMBINED_MODES_LOADING,
  FETCH_COMBINED_MODES_SUCCESS,
  FETCH_COMBINED_MODES_FAILURE,
  FETCH_GLOBAL_WORK_MODES_FAILURE,
  FETCH_GLOBAL_WORK_MODES_SUCCESS,
  FETCH_GLOBAL_WORK_MODES_LOADING
} from '../Types/combinedModesTypes';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCombinedModesSuccess = data => {
  return {
    type: FETCH_COMBINED_MODES_SUCCESS,
    payload: data
  };
};

export const fetchCombinedModesError = error => {
  return {
    type: FETCH_COMBINED_MODES_FAILURE,
    payload: error
  };
};

export const fetchCombinedModes = start => {
  return dispatch => {
    dispatch({
      type: FETCH_COMBINED_MODES_LOADING
    });

    api
      .get(`${API_URL}Operation/getCombinedModes/${start}`)
      .then(response => {
        const requests = response.data.data;
        dispatch(fetchCombinedModesSuccess(requests));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchCombinedModesError(errorMsg));
      });
  };
};

export const fetchGlobalWorkModesSuccess = data => {
  return {
    type: FETCH_GLOBAL_WORK_MODES_SUCCESS,
    payload: data
  };
};

export const fetchGlobalWorkModesError = error => {
  return {
    type: FETCH_GLOBAL_WORK_MODES_FAILURE,
    payload: error
  };
};

export const fetchGlobalWorkModes = (start: Date) => {
  return dispatch => {
    dispatch({
      type: FETCH_GLOBAL_WORK_MODES_LOADING
    });

    api
      .get(`${API_URL}Operation/getGlobalCombinedModes/${start}`)
      .then(response => {
        const workModes = response.data.data;
        dispatch(fetchGlobalWorkModesSuccess(workModes));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchGlobalWorkModesError(errorMsg));
      });
  };
};
export const workModeUsers = async (date, timeslot, mode) => {
  try {
    const response = await api.get(
      `${API_URL}Operation/getGlobalWorkModesUsers/${encodeURIComponent(date)}/${encodeURIComponent(
        timeslot
      )}/${encodeURIComponent(mode)}`
    );
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching work mode users:', error.message);
    throw new Error('Failed to fetch users. Please try again later.');
  }
};
